(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["footer-policy-list"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
  const toggleBtn = document.querySelector('.policy-toggle');
  const policyList = document.querySelector('.policy_list');

  if(toggleBtn && policyList){
    toggleBtn.addEventListener('click', function(){
      if(policyList.style.display === 'flex'){
        policyList.style.display = 'none';
        toggleBtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="white" viewBox="0 0 16 16">
          <path d="M8 1v14M1 8h14"/>
        </svg>`;
      } else {
        policyList.style.display = 'flex';
        toggleBtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="white" viewBox="0 0 16 16">
          <path d="M1 1l14 14M15 1L1 15"/>
        </svg>`;
      }
    });
  }
});
  } catch(e) { console.error(e); }
})();

})();
